import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "player_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.633 22.243a1.92 1.92 0 0 1-1.628-2.03c.097-1.43.343-2.542.978-3.186 1.153-1.168 1.757-1.298 2.267-1.408.107-.022.21-.044.311-.075.336-.1.37-.12.481-.19.086-.054.217-.136.564-.304.801-.39 1.324-.671 1.778-.988l.138-.097c.451-.315 1.07-.748 1.29-1.067l-.103-1.837s-.523-1.13-.523-1.376c0 0-.313.352-.627-.142l-.041-.064c-.349-.548-1.23-1.933-.761-2.408 0 0 .21-.14.382 0 0 0-1.22-2.93 1.08-4.873s4.077-1.2 5.401-.035c1.324 1.165 1.116 3.459 1.116 3.459s.975-.246.906.742c-.007.111-.014.233-.02.36-.055 1.009-.128 2.374-1.025 1.652 0 0 .105 1.13-.07 1.59-.174.458 0 2.824 0 2.824s1.813 1.906 2.23 2.225c.418.319 1.186.636 2.406 1.13.267.108.55.201.834.295 1.01.332 2.033.67 2.441 1.717.235.603.42 1.376.54 2.123.155.97-.52 1.819-1.475 1.976-1.877.31-5.222.744-9.209.744-4.044 0-7.648-.447-9.66-.757Z"
    }, null, -1)
  ]))]))
}
export default { render: render }